export enum VisibilityOptions {
  ALL = 'All',
  TOGGLE = 'Toggle',
  NONE = 'None',
}
